import { ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DiagnoseTemplateList } from '../../../business-entities/diagnose-template-modal';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { DiagnoseTemplateBusinessService } from './../../../business-services/diagnose-template.service';
import { AddDiagnoseTemplateComponent } from './add-diagnose-template/add-diagnose-template/add-diagnose-template.component';
import { EditDiagnoseTemplateComponent } from './edit-diagnose-template/edit-diagnose-template/edit-diagnose-template.component';

@Component({
  selector: 'app-diagnose-template',
  templateUrl: './diagnose-template.component.html'
})
export class DiagnoseTemplateComponent implements OnInit, OnDestroy {
  currentlagSub: Subscription
  diagnoseTemplateList: DiagnoseTemplateList[] = [];
  popupCloseResult = false;
  userRoleRightsDetails: UserRoleMenu;
  templateListRequestModel: any = {};
  searchTerm = '';
  throttle = 100;
  scrollDistance = 1;
  totalCount: number = 0;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private route: ActivatedRoute,
    private currentLanguageService: CurrentLanguage,
    private cd: ChangeDetectorRef,
    private translate: TranslateService,
    private cookieservice: CookieService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private diagnoseTemplateService: DiagnoseTemplateBusinessService,
    private userService: UserDataService,
    config: NgbModalConfig,
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.templateListRequestModel.SortColumn = column;
    this.templateListRequestModel.sortDirection = direction;
    this.templateListRequestModel.startRecordNumber = 0;
    this.diagnoseTemplateList = [];
    this.getDiagnoseTemplateList();
  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.DiagnoseTemplate);
    this.templateListRequestModel = {
      LanguageCode: '',
      startRecordNumber: 0,
      PageSize: 25,
      SortColumn: 'Name',
      sortDirection: 'DESC',
      searchTerm: this.searchTerm
    };
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.templateListRequestModel.LanguageCode = x;
    });
    this.diagnoseTemplateList=[];
    this.getDiagnoseTemplateList();
  }

  onSearchFilter(){
    this.templateListRequestModel.searchTerm = this.searchTerm;
    this.templateListRequestModel.startRecordNumber = 0;
    this.diagnoseTemplateList = [];
    this.getDiagnoseTemplateList();
  }
  onScrollDown(_ev) {
    if(this.totalCount > this.diagnoseTemplateList.length){
      this.templateListRequestModel.startRecordNumber = this.diagnoseTemplateList.length
      this.getDiagnoseTemplateList();
    }
  }

  getDiagnoseTemplateList() {
    this.spinner.show();
      this.diagnoseTemplateService.getDiagnoseTemplateList(this.templateListRequestModel).then((response) => {
        this.totalCount = 0;
        this.diagnoseTemplateList.push(...this.diagnoseTemplateMapping(response));
        if(this.diagnoseTemplateList.length > 0)
          this.totalCount = this.diagnoseTemplateList[0].totalCount;
        this.spinner.hide();
      })
    .catch(()=>{
      this.spinner.hide();
    })
  }

  private diagnoseTemplateMapping(diagnoseTemplateList: any) {
    let supperArray = [];
    if (diagnoseTemplateList && diagnoseTemplateList.length > 0) {
      for (let index = 0; index < diagnoseTemplateList.length; index++) {
        const element = diagnoseTemplateList[index];
        let single = Object();
        single.rowNumber = this.templateListRequestModel.startRecordNumber+ 1 + index;
        single.descriptionId = element.descriptionId;
        single.templateId = element.templateId;
        single.totalCount = element.totalCount;
        if (element.listType === 1) {
          single.listType = 'Diagnose';
        }
        else if (element.listType === 2) {
          single.listType = 'Cause';
        }
        else if(element.listType === 3){
          single.listType = 'Solution and Result';
        }
        else{
          single.listType = 'Cause Code';
        }
        single.isActive = element.isActive;
        single.name = element.name
        single.templates = element.templates
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  deleteDiagnoseTemplate(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblDiagnoseTemplate"),true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => { 
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.diagnoseTemplateService.deleteDiagnoseTemplate(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let deletedmsg = this.translate.instant("lblDiagnoseTemplateDeleted");
            this.toastr.success(deletedmsg)
            this.templateListRequestModel.LanguageCode = this.cookieservice.get('userSelectedLanguage');
            this.templateListRequestModel.startRecordNumber = 0;
            this.diagnoseTemplateList = [];
            this.getDiagnoseTemplateList();
          }
        });
      }
    });
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  onEdit(id: number) {
    this.diagnoseTemplateService.diagnoseTemplateId = id
      const modalref = this.modalService.open(EditDiagnoseTemplateComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
          //modal result
      });
  }
  onAdd() {
    const modalref = this.modalService.open(AddDiagnoseTemplateComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
       //modal result
      });
  }

  ngOnDestroy(): void {
    this.currentlagSub.unsubscribe();
  }
}
